export default __webpack_public_path__ + "static/media/flag-tr.9da272ed.svg";